// extracted by mini-css-extract-plugin
module.exports = {"balance_number":"Balance_balance_number__dAo6P","container_card":"Balance_container_card__3aZVh"};